import { memo } from "react";
import { useMediaDataRoom } from "features/mediaDataRoom/contexts";
import { MediaDataRoomVersion } from "features/mediaDataRoom/models";

interface AudienceV3CreatorProps {
  createdBy: string;
}

const AudienceV3Creator = memo<AudienceV3CreatorProps>(({ createdBy }) => {
  const { participants } = useMediaDataRoom(MediaDataRoomVersion.v3);
  const participant = participants.find((p) => p.emails.includes(createdBy));
  return `${participant?.name ?? "—"}${participant?.isCurrentUser ? " (you)" : ""}`;
});
AudienceV3Creator.displayName = "AudienceV3Creator";

export default AudienceV3Creator;
